import { render, staticRenderFns } from "./WizardNoChildBenefits.vue?vue&type=template&id=444c3e36&"
import script from "./WizardNoChildBenefits.vue?vue&type=script&lang=js&"
export * from "./WizardNoChildBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports